import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDgf3yItVvhG3DhzF2dX-QnijKaAfsjpqE',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'familycopilot-604c9.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'familycopilot-604c9',
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'familycopilot-604c9.firebasestorage.app',
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '838515681107',
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID || '1:838515681107:web:b9f8e4e3dbde7781f5e3a6',
};

const missingConfigValues = [
  firebaseConfig.apiKey,
  firebaseConfig.authDomain,
  firebaseConfig.projectId,
  firebaseConfig.storageBucket,
  firebaseConfig.messagingSenderId,
  firebaseConfig.appId,
].some((value) => !value || value.startsWith('YOUR_FIREBASE_'));

export const isFirebaseConfigured = !missingConfigValues;

const app = isFirebaseConfigured ? initializeApp(firebaseConfig) : null;

export const auth = app ? getAuth(app) : null;
export const db = app ? getFirestore(app) : null;
